import React from 'react';
import ExamsListing from './ExamsListing';

const ExamDetails = () => {
    return (
        <div className='exam-details-card'>
            <h2>Exam Details</h2>
            <ExamsListing />

        </div>
    );
}

export default ExamDetails;